/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { arrayMove } from "react-sortable-hoc";

/*component */
import SpeakerInputs from "./SpeakerInputs";
import SortableGrid from "../../shared/SortableGrid";
import CollectionAccordion from "../../shared/Forms/CollectionAccordion";

class SessionSpeakers extends Component {
	constructor(props) {
		super(props);
		this.state = {
			count: 0,
			shouldDisable: false,
			expandedIndex: null,
			initialLoad: false,
		};
	}

	componentDidUpdate(prevProps) {
		if (this.props.values !== prevProps.values && this.props.values.speakers && !this.state.initialLoad) {
			const { speakers } = this.props.values;
			this.setState({
				count: speakers.length,
				initialLoad: true,
			});
		}
	}

	getOptionsShown = shown => {
		if (shown) {
			this.setState({
				shouldDisable: true,
			});
		} else {
			this.setState({
				shouldDisable: false,
			});
		}
	};

	toggleCollectionItem = index => {
		const { expandedIndex } = this.state;
		if (expandedIndex === index) {
			this.setState({
				expandedIndex: null,
			});
		} else {
			this.setState({
				expandedIndex: index,
			});
		}
	};

	onSortEnd = ({ oldIndex, newIndex }) => {
		const { values, formApi } = this.props;
		if (values && values.speakers) {
			const { setValues } = formApi;
			const { speakers } = values;
			setValues({
				...values,
				speakers: arrayMove(speakers, oldIndex, newIndex),
			});
		}
	};

	addSessionSpeaker = () => {
		const { count } = this.state;
		this.setState({
			count: count + 1,
			expandedIndex: count,
		});
	};

	deleteSessionSpeaker = index => {
		const { values, formApi } = this.props;
		const { count } = this.state;
		if (values && values.speakers) {
			const { setValues } = formApi;
			const { speakers } = values;
			this.setState(
				{
					count: count - 1,
				},
				setValues({
					...values,
					speakers: [...speakers.slice(0, index), ...speakers.slice(index + 1)],
				})
			);
		} else if (count > 0) {
			this.setState({
				count: count - 1,
			});
		}
	};

	copySessionSpeaker = index => {
		const { values, formApi } = this.props;
		const { count } = this.state;
		if (values && values.speakers) {
			const { setValues } = formApi;
			const { speakers } = values;
			this.setState(
				{
					count: count + 1,
				},
				setValues({
					...values,
					speakers: [...speakers, speakers[index]],
				})
			);
		}
	};

	renderSessionSpeakers = () => {
		const { sessionSpeakers, values } = this.props;
		const { count, expandedIndex } = this.state;
		const value = values && values.speakers ? values.speakers : [];
		let sessionSpeakersElements = [];
		for (var i = 0; i < count; i++) {
			const title = value[i] ? (value[i].title ? value[i].title : value[i].name ? value[i].name : "") : "";
			sessionSpeakersElements.push(
				<CollectionAccordion
					key={i}
					title={title}
					expanded={expandedIndex === i}
					index={i}
					copyCollection={this.copySessionSpeaker}
					deleteCollection={this.deleteSessionSpeaker}
					toggleCollectionItem={this.toggleCollectionItem}
					getOptionsShown={this.getOptionsShown}
				>
					<SpeakerInputs sessionSpeakers={sessionSpeakers} index={i} />
				</CollectionAccordion>
			);
		}
		return sessionSpeakersElements;
	};

	render() {
		const { shouldDisable } = this.state;

		return (
			<div>
				<SortableGrid
					shouldDisable={shouldDisable}
					onSortEnd={this.onSortEnd}
					createNew={this.addSessionSpeaker}
					title="Session Speakers"
				>
					{this.renderSessionSpeakers()}
				</SortableGrid>
			</div>
		);
	}
}

SessionSpeakers.propTypes = {
	values: PropTypes.object,
	formApi: PropTypes.object,
	sessionSpeakers: PropTypes.array,
};

export default SessionSpeakers;
